import React, { useState } from "react";
import { useSelector } from "react-redux";
import classes from "./Main.module.scss";
import { getUserInfo } from "../../reducks/users/selectors";
import { SEARCH_SCREENS } from "../../functions/order/orderSearchModel";
import { getSortField } from "../../functions/order/applyOrderSearch";
import { useOrderSearchConditions } from "../../hooks/useOrderSearchConditions";
import { useOrdersSubscription } from "../../hooks/useOrdersSubscription";
import OrderSearchPanel from "../order/search/OrderSearchPanel";
import HeaderController from "./header/HeaderController";
import TableArea from "./table/TableArea";

const Main = () => {
  const userInfo = useSelector(getUserInfo);
  // 検索条件は URL(?date=...&from=...) が唯一の情報源。
  // リロード・リンク共有で同じ条件が復元される(URL > localStorage > ロール既定値)
  const { conditions, patchConditions, resetConditions, isReady } =
    useOrderSearchConditions(SEARCH_SCREENS.PROCESSING);
  // isReady まで購読を待つ(localStorage 復元前の既定値で1回無駄に購読しないため)
  const { orders, isLoading, error } = useOrdersSubscription({
    conditions,
    loginUserEmail: userInfo.email,
    enabled: isReady,
  });
  const [filteredOrders, setFilteredOrders] = useState([]);

  return (
    <div className={classes.root}>
      <OrderSearchPanel
        screen={SEARCH_SCREENS.PROCESSING}
        conditions={conditions}
        onChange={patchConditions}
        onReset={resetConditions}
        isLoading={isLoading}
        error={error}
        resultCount={orders.length}
      />
      <HeaderController filteredOrders={filteredOrders} />
      <TableArea
        orders={orders}
        filteredOrders={filteredOrders}
        setFilteredOrders={setFilteredOrders}
        initialSortField={getSortField(conditions)}
      />
    </div>
  );
};

export default Main;
